module.exports = __webpack_public_path__ + "img/guigecanshu.b3cdcdea.png";